import { createSlice } from '@reduxjs/toolkit'
const defaultDescription =
  'Need an exceptional speaker? UTA Speakers represents the world’s greatest talent. Find the perfect keynote for your next corporate event or conference.'

const defaultKeywords =
  'UTA Speakers, keynote speakers, celebrity speakers, professional speakers, conference speakers, corporate speakers, United Talent Agency'

const initialState = {
  seo: {
    pageTitle: "World's Most Requested Experts | UTA Speakers",
    pageDescription: defaultDescription,
    ogImage: null,
    keywords: defaultKeywords,
  },
}

export const speakersDefaultSeoState = {
  pageTitle: 'All Speakers | UTA Speakers',
  pageDescription:
    'Browse all UTA Speakers, from business and politics, technology and entertainment, literature, sports, and more.',
  ogImage: null,
  keywords: defaultKeywords,
}

export const contactSeoState = {
  pageTitle: 'Contact | UTA Speakers',
  pageDescription: defaultDescription,
  ogImage: null,
  keywords: defaultKeywords,
}

export const bookNowSeoState = {
  pageTitle: 'Book Now | UTA Speakers',
  pageDescription: defaultDescription,
  ogImage: null,
  keywords: defaultKeywords,
}

export const generateSpeakersTags = (data) => {
  if (data.pageTitle && data.pageDescription) {
    return {
      pageTitle: `${data?.pageTitle ? `${data?.pageTitle} |` : ''} Speaker ${
        data?.isType
      } | UTA Speakers`,
      pageDescription: data.pageDescription ? data?.pageDescription : '',
      ogImage: data?.ogImage || null,
      keywords: data?.keywords || defaultKeywords,
    }
  } else {
    return speakersDefaultSeoState
  }
}

export const generateSpeakerProfileTags = (data) => {
  return {
    pageTitle: data?.pageTitle,
    pageDescription: data?.pageDescription,
    ogImage: data?.ogImage,
    keywords: data?.keywords || defaultKeywords,
    // A speaker profile is a person, not a generic site page.
    ogType: 'profile',
  }
}

export const headSlice = createSlice({
  name: 'head',
  initialState,
  speakersDefaultSeoState,
  contactSeoState,
  bookNowSeoState,
  reducers: {
    setDefaultPageSeo: (state) => {
      state.seo = initialState.seo
    },
    setSpeakersDefaultSeo: (state) => {
      state.seo = speakersDefaultSeoState
    },
    setPageSeo: (state, action) => {
      state.seo = action.payload
    },
    setSpeakersSeo: (state, action) => {
      state.seo = generateSpeakersTags(action.payload)
    },
    setProfileSeo: (state, action) => {
      state.seo = generateSpeakerProfileTags(action.payload)
    },
    setContactSeo: (state) => {
      state.seo = contactSeoState
    },
    setBookNowSeo: (state) => {
      state.seo = bookNowSeoState
    },
  },
})

// Selectors
export const getSeoDetails = (state) => state.head.seo

// Action creators are generated for each case reducer function
export const {
  setDefaultPageSeo,
  setSpeakersDefaultSeo,
  setPageSeo,
  setProfileSeo,
  setSpeakersSeo,
  setContactSeo,
  setBookNowSeo,
} = headSlice.actions

export default headSlice.reducer
